import React from "react";
import ChatWindow from "../ChatWindow";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";

const Home = () => {
  return (
    <>
      <ChatWindow />
    </>
  )
}

export default Home
